import { render, staticRenderFns } from "./StatisticsTable.vue?vue&type=template&id=b995d0f4&scoped=true"
import script from "./StatisticsTable.vue?vue&type=script&lang=js"
export * from "./StatisticsTable.vue?vue&type=script&lang=js"
import style0 from "./StatisticsTable.vue?vue&type=style&index=0&id=b995d0f4&prod&lang=less&scoped=true"
import style1 from "./StatisticsTable.vue?vue&type=style&index=1&id=b995d0f4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b995d0f4",
  null
  
)

export default component.exports